<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
	import md5 from 'js-md5';
    import axios from "axios";
    import  {regionData}  from '../assets/data/regioe.js';
	export default {
		data() {
			return {

			}
		},
		methods: {},
		mounted() {
		}
	}
</script>





// WEBPACK FOOTER //
// RouteView.vue?0ccfd762